







































































































import { Component, Prop } from 'vue-property-decorator';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import FiltrosBusqueda from '@/pantallas/Conecta/PreparacionEquipos/FiltrosBusqueda.vue';
import ModalCrear from '@/pantallas/Conecta/PreparacionEquipos/ModalCrear.vue';
import ModalAsignacion from '@/pantallas/Conecta/PreparacionEquipos/ModalAsignacion.vue';

import { Funcionalidades } from '@/config/funcionalidades';
const { AgGridVue } = require('ag-grid-vue');
import { actionsEvent } from '@/setup';
import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ValueFormatterParams,
  ICellRendererParams,
  GetQuickFilterTextParams,
} from 'ag-grid-community';
import { LoadingService } from '@/services/loadingService';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import moment from 'moment';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { fetchMS } from '@/pantallas/Conecta/PreparacionEquipos/fetchMS';
import {
  codigoAccionesMenuItem,
  PermisoAccion,
} from '@/views/base/VariablesPermisos';

import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import config from '@/config/index';
import { Validator } from 'vee-validate';
import ValidaRut from '@/config/validaRut';

@Component({
  components: {
    MantenedorGrid,
    MantenedorGridSinCodigo,
    GridComponent: AgGridVue,
    FiltrosBusqueda,
    ModalCrear,
    ModalAsignacion,
    FormFieldsContainer,
  },
})
export default class AsignacionNoSeriado extends ComponenteBase {
  readonly codigoAccionesMenuItem = Object.values(codigoAccionesMenuItem);
  readonly funcionalidad: Funcionalidades =
    Funcionalidades.PreparacionEquiposNoSeriados;

  @Prop({
    required: true,
    default: { asignumero: '', estado: '', asigdeta_finalizado: '' },
  })
  regSeleccionado: any;

  readonly loadingService = new LoadingService();

  pagina: number = 1;
  hashpaginacion: string = '';
  rowcount: number = 0;
  total_registros: number = 0;
  cant_regs_pag: number = 50;
  filtrobusquedagrilla: string = '';
  listaReq: any[] = [];
  listaEquipos: any[] = [];
  id_editar: string = '';

  columnApi: any = null;
  gridEvent: any = null;
  serverSide: any = null;
  gridApi: GridApi = null;
  showReporteGenerado: boolean = false;
  texto_reporte: string = '';
  showModalNew: boolean = false;
  showModalAsignacion: boolean = false;
  showForm: boolean = false;
  deshabilitar: boolean = false;

  vr: ValidaRut = new ValidaRut();
  anio: any = '';
  dictionaryFormErrors: any = {};
  evt: any;

  loading: boolean = false;

  formFields: FormFieldDefMap = {
    equipo: {
      label: 'Equipo',
      id: 'equipo',
      value: '',
    },
    cantidad: {
      label: 'Cantidad',
      id: 'cantidad',
      value: '',
    },
    descripcion: {
      label: 'Descripción',
      id: 'descripcion',
      value: '',
    },
  };

  readonly gridOptions: GridOptions = {
    columnDefs: [
      {
        headerName: 'Estado Finalización',
        field: 'asigdeta_finalizado',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
        minWidth: 150,
        cellRenderer: this.getHtmlEstadoFinalizacion,
      },
      {
        headerName: 'Asignación',
        field: 'asignumero',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
        minWidth: 150,
      },
      {
        headerName: 'Línea',
        field: 'asigdeta_linea',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
        minWidth: 150,
      },
      {
        headerName: 'Cantidad',
        field: 'asigdeta_cant',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
        minWidth: 150,
      },
      {
        headerName: 'Tipo Equipo',
        field: 'tipoeq',
        cellStyle: { textAlign: 'left' },
        width: 150,
        minWidth: 150,
      },
      {
        headerName: 'Observación',
        field: 'asigdeta_obs',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
        minWidth: 150,
      },
    ],
    pagination: true,
    paginationPageSize: this.cant_regs_pag,
    cacheBlockSize: this.cant_regs_pag,
    paginationAutoPageSize: false,
    rowModelType: 'serverSide',
    serverSideDatasource: this.serverSide,
    onGridReady: this.handleGridReady,
    onModelUpdated: this.onModelUpdated,

    overlayNoRowsTemplate: 'No hay filas para mostrar',
    processCellForClipboard: ({ value }) => {
      return value instanceof moment
        ? this.formatFecha(value as moment.Moment)
        : value;
    },
  };

  async handleGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;
    //this.gridApi.rowModel.rowsToDisplay = this.rowcount;
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    let self = this;
    this.serverSide = {
      getRows(event: any): void {
        event.request.paginationSize = self.gridOptions.cacheBlockSize;
        self.pagina = event.request.startRow / self.cant_regs_pag + 1;
        let body: any = {};
        body.pagina = self.pagina;
        body.hashpaginacion = self.hashpaginacion;
        body.asignumero = self.regSeleccionado.asignumero;
        self.loadingService.showLoading(undefined, 'grillaNoSeriado');

        fetchMS(body, 'get_asignacion_detalle')
          .then((response: any) => {
            if (response.data.CODIGO_RESPUESTA == '2') {
              event.successCallback([{}], 0);
              self.gridApi.showNoRowsOverlay();
              return;
            }
            if (response.data.CODIGO_RESPUESTA == '1') {
              if (response.data.data.LISTA.length === 0) {
                event.successCallback([{}], 0);
                self.gridApi.showNoRowsOverlay();
              } else {
                event.successCallback(
                  response.data.data.LISTA,
                  response.data.data.TOTAL_REGISTROS
                );
                self.hashpaginacion = response.data.data.hash1;
                self.rowcount =
                  response.data.rowcount === null ? 0 : response.data.rowcount;
                self.total_registros =
                  response.data.data.TOTAL_REGISTROS === null ||
                  response.data.data.TOTAL_REGISTROS === undefined
                    ? 0
                    : response.data.data.TOTAL_REGISTROS;

                self.cant_regs_pag =
                  response.data.data.cant_regs_pag === null ||
                  response.data.data.cant_regs_pag === undefined
                    ? 50
                    : response.data.data.cant_regs_pag;
                self.gridApi.hideOverlay();
                self.autoSizeAll(true);
              }
            } else {
              event.successCallback([{}], 0);
            }
          })
          .catch((error: any) => {
            event.successCallback([{}], 0);
            self.$snotify.error('Ocurrió un error. Intente nuevamente.', {
              timeout: 3000,
            });
          })
          .finally(() => {
            self.gridApi.setDomLayout('autoHeight');
            self.loadingService.hideLoading('grillaNoSeriado');
          });
      },
    };
    this.gridApi.setServerSideDatasource(this.serverSide);
    this.gridApi.setDomLayout('autoHeight');
  }
  initialize() {
    this.dictionaryFormErrors = {
      custom: {
        ano: {
          required: () => config.errorMensajes.textoRequerido,
          numeric: config.errorMensajes.soloNumeros,
        },
      },
    };
    this.$validator.localize('es', this.dictionaryFormErrors);
  }
  handleCierreModalCrear() {
    this.showModalNew = false;
  }
  handleCierreModalAsignacion() {
    this.showModalAsignacion = false;
  }

  filtros2body() {
    let body: any = {};

    let fechaInicio: any;
    let fechaFin: any;
    if (moment.isMoment(this.formFields.fechaInicio.value)) {
      fechaInicio = moment(this.formFields.fechaInicio.value).format('L');
    }
    if (moment.isMoment(this.formFields.fechaFin.value)) {
      fechaFin = moment(this.formFields.fechaFin.value).format('L');
    }
    body.fecha_inicio = fechaInicio;
    body.fecha_fin = fechaFin;
    body.requerimiento = this.formFields.requerimiento.value;

    return body;
  }

  filtroAlertas(loadWidget: boolean) {
    this.gridApi.setServerSideDatasource(this.serverSide);
  }

  autoSizeAll(skipHeader: boolean) {
    this.columnApi.autoSizeColumns(
      this.columnApi.getAllDisplayedColumns().map((x: any) => x.colId)
    );
  }

  async getTipoEquipos() {
    try {
      this.loadingService.showLoading(undefined, 'getTipoEquipos');
      this.loading = true;
      let resp: any = (await this.cargarTiposEquipos()) || [];
      if (resp.data.CODIGO_RESPUESTA != '1') {
        this.$snotify.error(resp.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        return;
      }
      this.listaEquipos = resp.data.data;
    } catch (err) {
      console.error('Error: ', err);
    } finally {
      this.loading = false;
      this.loadingService.hideLoading('getTipoEquipos');
    }
  }

  cargarTiposEquipos() {
    this.loadingService.showLoading(undefined, 'cargarTiposEquipos');
    let self = this;
    return fetchMS(
      {
        tag: 'all_series',
        serienumero: '',
      },
      'getEquipos'
    )
      .catch(error => {
        if (error.message == 'Network Error') {
          this.$snotify.error(
            'Ha ocurrido un error al intentar obtener los equipos',
            { timeout: 3000 }
          );
        } else if (error.response.status != 404) {
          this.$snotify.error(
            'Ha ocurrido un error al intentar obtener los eqipos',
            { timeout: 3000 }
          );
        }
      })
      .finally(() => self.loadingService.hideLoading('cargarTiposEquipos'));
  }
  id_usuario: any;
  deleteRegistro(id: string) {
    this.loadingService.showLoading(undefined, 'deleteAsignacionNoSeriado');
    let self = this;
    this.id_usuario = JSON.parse(window.localStorage.user).id;
    return fetchMS(
      { id: id, id_usuario: this.id_usuario, modulo: this.funcionalidad },
      'deleteAsignacionNoSeriado'
    )
      .catch(error => {
        if (error.message == 'Network Error') {
          this.$snotify.error(
            'Ha ocurrido un error al intentar obtener los equipos',
            { timeout: 3000 }
          );
        } else if (error.response.status != 404) {
          this.$snotify.error(
            'Ha ocurrido un error al intentar obtener los eqipos',
            { timeout: 3000 }
          );
        }
      })
      .finally(() =>
        self.loadingService.hideLoading('deleteAsignacionNoSeriado')
      );
  }
  respuesta: any;
  async handleGuardarClick() {
    let self = this;
    this.respuesta = await this.$validator.validateAll();
    if (this.respuesta == false) {
      self.$snotify.error('El campo cantidad debe ser numérico.', {
        timeout: 3000,
      });
      return;
    }
    this.loadingService.showLoading(undefined, 'agregarNoSeriado');
    let body: any = {};
    body.asignumero = this.regSeleccionado.asignumero;
    body.equipo = this.formFields.equipo.value;
    body.cantidad = this.formFields.cantidad.value;
    body.descripcion = this.formFields.descripcion.value;
    body.id_usuario = JSON.parse(window.localStorage.user).id;
    body.id_editar = this.id_editar;
    body.modulo = this.funcionalidad;

    return fetchMS(body, 'agregarNoSeriado')
      .then(resp => {
        if (resp.data.CODIGO_RESPUESTA == '1') {
          self.handleVolverClick();
        } else {
          this.$snotify.error(resp.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch(error => {
        if (error.message == 'Network Error') {
          this.$snotify.error('Ha ocurrido un error al ingresar el equipo', {
            timeout: 3000,
          });
        } else if (error.response.status != 404) {
          this.$snotify.error('Ha ocurrido un error al ingresar el equipo', {
            timeout: 3000,
          });
        }
      })
      .finally(() => {
        self.loadingService.hideLoading('agregarNoSeriado');
      });
  }
  handleVolverClick() {
    this.formFields.equipo.value = '';
    this.formFields.cantidad.value = '';
    this.formFields.descripcion.value = '';
    this.showForm = false;
    this.gridApi.setServerSideDatasource(this.serverSide);
    this.hashpaginacion = '';
  }

  //Busca dentro del resultado de la grilla
  searchData() {
    this.gridApi.setQuickFilter(this.filtrobusquedagrilla);
    this.gridApi.setDomLayout('autoHeight');
  }

  get fechaMaxima() {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();

    let fechaMax = yyyy + '-' + mm + '-' + dd;
    return fechaMax;
  }

  handlerContexTmenu(e: any) {
    e.preventDefault();
  }

  formatFecha(fecha: moment.Moment) {
    return fecha.format('DD/MM/YYYY');
  }

  fechaQuickFilterGetter(params: GetQuickFilterTextParams) {
    return this.formatFecha(params.value);
  }

  fechaValueFormatter(params: ValueFormatterParams) {
    return this.formatFecha(params.value);
  }

  accionCrear: PermisoAccion = {
    accionCodigo: 2,
    visible: false,
  };
  accionEliminar: PermisoAccion = {
    accionCodigo: 5,
    visible: false,
  };
  accionEditar: PermisoAccion = {
    accionCodigo: 3,
    visible: false,
  };

  accionesTotales: PermisoAccion[] = [
    this.accionEliminar,
    this.accionEditar,
    this.accionCrear,
  ];

  async handleEliminarClick(params: ICellRendererParams) {
    let resp: any = (await this.deleteRegistro(params.data.id)) || [];
    if (resp.data.CODIGO_RESPUESTA != '1') {
      this.$snotify.error(resp.data.MENSAJE_RESPUESTA, { timeout: 3000 });
    } else {
      this.hashpaginacion = '';
      this.gridApi.setServerSideDatasource(this.serverSide);
      this.$snotify.success('Registro eliminado correctamente.', {
        timeout: 3000,
      });
    }
  }
  handleEditarClick(params: ICellRendererParams) {
    this.id_editar = params.data.id;
    this.formFields.cantidad.value = params.data.asigdeta_cant;
    this.formFields.equipo.value = params.data.tipoeqid;
    this.formFields.descripcion.value = params.data.asigdeta_obs;

    this.showForm = true;
  }
  handleCierreModalVerDetalle() {}

  closeReporte() {
    this.showReporteGenerado = false;
    this.texto_reporte = '';
  }

  actions() {
    actionsEvent.onEliminar(this.handleEliminarClick);
    actionsEvent.onEditar(this.handleEditarClick);
  }

  constructor() {
    super();
    this.actions();
  }

  validateState() {
    if (
      (this.regSeleccionado != null &&
        ['Finalizado', 'Anulado'].includes(this.regSeleccionado.estado)) ||
      this.regSeleccionado.asigdeta_finalizado === 't'
    ) {
      this.deshabilitar = true;
    }
  }

  async mounted() {
    try {
      await Promise.all([
        this.validateState(),
        this.getTipoEquipos(),
        this.initialize(),
      ]);
    } catch (err) {
      console.error('Error: ', err);
    }
  }

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
    this.gridApi.setServerSideDatasource(this.serverSide);
  }

  getHtmlEstadoFinalizacion(params: any): string {
    if (params.data.asigdeta_finalizado === 't') {
      return '<i class="material-icons" title="Finalizado"  style="width: 24px; height: 24px; margin-top: 7%; color: green; border-radius: 50%;">done</i>';
    }
    return '<i class="material-icons" title="Sin Finalizar"  style="width: 24px; height: 24px; margin-top: 7%; color: red; border-radius: 50%;">close</i>';
  }
}
